import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import request from 'superagent';
import config from '../../../config';
import { formatCurrency } from '../../../helpers';
import conversionRates from '../../../conversionRates';

/*
    Panel de transferencia de cargos.
    Recibe los cargos ya seleccionados en la Cuenta Maestra (o Auxiliar) y permite
    escogerle un destino: una pieza ocupada por un huesped hospedado (Checked-in).
*/
class TransferCharges extends React.Component {
    state = {
        query: '',
        target: null,
        target_is_auxiliar: 0,
        confirming: false,
        currency: localStorage.getItem('lb.currency') || 'USD',
    }

    componentWillMount = () => {
        const { IdProperty, book, accounting_actions } = this.props;
        // Se limpia primero para no mostrar destinos viejos mientras llega la consulta
        accounting_actions && accounting_actions.clear_transfer_targets();
        accounting_actions && accounting_actions.fetch_transfer_targets({
            IdProperty,
            IdBook: book.IdBook
        });
    }

    // Los cargos se guardan en USD; la pantalla puede estar en VEF
    toDisplay = (amount, ConversionBS) => {
        const { currency } = this.state;
        return parseFloat(amount) * (currency === 'USD' ? 1 : (ConversionBS ?? conversionRates.R()?.usd ?? 1));
    }

    total = () => _.reduce(this.props.charges, (memo, c) => memo + this.toDisplay(c.Debit, c.ConversionBS), 0);

    onTransfer = () => {
        const { target, target_is_auxiliar } = this.state, { book, charges, IdProperty, source } = this.props;
        if (!target || this.state.micro) return;

        this.setState({ micro: true, error: null }, () => {
            request.post(`${config.apiEndpoint}/api/v4/accounting/transfer`)
                .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                .send({
                    IdBook: book.IdBook,
                    IdProperty,
                    Ids: _.map(charges, c => c.IdBookAccounting),
                    SourceIdBookRoom: source ? source.IdBookRoom : null,
                    TargetIdBook: target.IdBook,
                    TargetIdBookRoom: target.IdBookRoom,
                    TargetIsAuxiliar: target_is_auxiliar
                })
                .then(({ body }) => {
                    if (body && body.success) this.props.onDone && this.props.onDone(body, target);
                    else this.setState({ micro: false, error: (body && body.error && body.error.message) || 'No se pudo completar la transferencia' });
                }, (error) => {
                    const body = error.response && error.response.body;
                    this.setState({
                        micro: false,
                        confirming: false,
                        error: (body && body.error && body.error.message) || 'No se pudo completar la transferencia'
                    });
                });
        });
    }

    renderCharges = () => {
        const { charges } = this.props, { currency } = this.state;
        return <div className="bg-gray-3 black-input p-3" style={{ borderRadius: 6 }}>
            <div className="d-flex">
                <span className="poppins white font-12">Cargos a transferir</span>
                <span className="poppins blue font-12 ms-auto">{charges.length}</span>
            </div>
            <hr className="my-2" />
            <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                {charges.map(c => <div key={c.IdBookAccounting} className="d-flex py-1">
                    <div className="d-flex flex-column">
                        <span className="poppins white font-10">{c.Reason}</span>
                        <span className="poppins gray font-8">{moment(c.CreateDate).format('DD MMM YYYY · HH:mm')}</span>
                    </div>
                    <span className="poppins white font-10 ms-auto align-self-center">{formatCurrency(this.toDisplay(c.Debit, c.ConversionBS), currency)}</span>
                </div>)}
            </div>
            <hr className="my-2" />
            <div className="d-flex">
                <span className="poppins white font-12">Total</span>
                <span className="poppins blue font-14 ms-auto">{formatCurrency(this.total(), currency)}</span>
            </div>
        </div>
    }

    renderTargets = () => {
        const { transfer_targets } = this.props, { query, target } = this.state;

        if (!transfer_targets) return <div className="d-flex justify-content-center" style={{ height: 200 }}>
            <span className="align-self-center gray poppins font-12"><i className="fas fa-cog fa-spin me-2" />Buscando huéspedes hospedados...</span>
        </div>

        const needle = (query || '').toLowerCase().trim();
        const filtered = _.filter(transfer_targets, t => !needle
            || String(t.PieceLabel || '').toLowerCase().includes(needle)
            || String(t.GuestName || '').toLowerCase().includes(needle)
            || String(t.PNR || '').includes(needle)
            || String(t.RoomType || '').toLowerCase().includes(needle));

        if (!filtered.length) return <div className="d-flex justify-content-center" style={{ height: 200 }}>
            <span className="align-self-center gray poppins font-12 text-center">
                {transfer_targets.length ? 'Ningún huésped coincide con la búsqueda' : 'No hay huéspedes hospedados en otras piezas'}
            </span>
        </div>

        const floors = _.chain(filtered).groupBy(t => t.FloorLabel || t.FloorNumber || '—').value();

        return <div style={{ maxHeight: 'calc(100vh - 330px)', overflowY: 'auto' }}>
            {_.map(_.keys(floors), floor => <section key={floor} className="mb-3">
                <span className="poppins gray font-10 text-uppercase">Piso {floor}</span>
                <div className="d-flex flex-wrap mt-2">
                    {floors[floor].map(t => {
                        const selected = target && target.IdBookRoom === t.IdBookRoom;
                        return <div key={t.IdBookRoom}
                            onClick={() => this.setState({ target: t, target_is_auxiliar: 0, error: null })}
                            className={`black-input pointer p-3 me-3 mb-3 ${selected ? 'bg-blue' : 'bg-gray-3'}`}
                            style={{ width: 230, borderRadius: 6, border: selected ? '1px solid #008db5' : '1px solid transparent' }}>
                            <div className="d-flex">
                                <span className="poppins white font-16">{t.PieceLabel}</span>
                                {selected && <i className="fas fa-check-circle white font-14 ms-auto align-self-center" />}
                            </div>
                            <span className="poppins white font-10 d-block text-truncate">{t.GuestName || 'Sin huésped asignado'}</span>
                            <span className={`poppins font-8 d-block ${selected ? 'white' : 'gray'}`}>
                                Reserva #{t.PNR} · {t.RoomType}
                            </span>
                            <span className={`poppins font-8 d-block ${selected ? 'white' : 'gray'}`}>
                                Salida {moment(t.CheckOut).format('DD MMM')}
                            </span>
                        </div>
                    })}
                </div>
            </section>)}
        </div>
    }

    renderDestination = () => {
        const { target, target_is_auxiliar, currency } = this.state;
        if (!target) return <></>

        return <div className="bg-gray-3 black-input p-3 mt-3" style={{ borderRadius: 6 }}>
            <span className="poppins white font-12">Cuenta destino</span>
            <hr className="my-2" />
            <div onClick={() => this.setState({ target_is_auxiliar: 0 })} className="d-flex pointer py-2">
                <i className={`${target_is_auxiliar ? 'far fa-circle gray' : 'fas fa-circle blue'} align-self-center me-2`} />
                <div className="d-flex flex-column">
                    <span className="poppins white font-10">Cuenta Maestra</span>
                    <span className="poppins gray font-8">Reserva #{target.PNR} · Balance {formatCurrency(target.MasterBalance || 0, 'USD')}</span>
                </div>
            </div>
            <div onClick={() => this.setState({ target_is_auxiliar: 1 })} className="d-flex pointer py-2">
                <i className={`${target_is_auxiliar ? 'fas fa-circle blue' : 'far fa-circle gray'} align-self-center me-2`} />
                <div className="d-flex flex-column">
                    <span className="poppins white font-10">Cuenta Auxiliar · Pieza {target.PieceLabel}</span>
                    <span className="poppins gray font-8">Balance {formatCurrency(target.AuxiliarBalance || 0, 'USD')}</span>
                </div>
            </div>
        </div>
    }

    renderConfirmation = () => {
        const { target, target_is_auxiliar, currency, micro } = this.state, { charges, book } = this.props;

        return <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1100, backgroundColor: 'rgba(0,0,0,.6)' }}>
            <div className="black-input bg-gray-2 p-4 align-self-center" style={{ width: 460 }}>
                <h3 className="white poppins text-center">Confirmar operación</h3>
                <h6 className="blue text-center poppins">TRANSFERIR CARGOS</h6>
                <hr className="w-50 mx-auto" />
                <div className="d-flex justify-content-center my-3">
                    <div className="text-center px-3">
                        <span className="poppins gray font-8 d-block">DESDE</span>
                        <span className="poppins white font-12 d-block">Reserva #{book.PNR}</span>
                        <span className="poppins gray font-8 d-block">{this.props.source ? `Cuenta Auxiliar ${this.props.source.PieceLabel}` : 'Cuenta Maestra'}</span>
                    </div>
                    <i className="fas fa-arrow-right blue font-16 align-self-center px-2" />
                    <div className="text-center px-3">
                        <span className="poppins gray font-8 d-block">HACIA</span>
                        <span className="poppins white font-12 d-block">Pieza {target.PieceLabel}</span>
                        <span className="poppins gray font-8 d-block">{target_is_auxiliar ? 'Cuenta Auxiliar' : `Cuenta Maestra · #${target.PNR}`}</span>
                    </div>
                </div>
                <h6 className="white text-center poppins">
                    Se transferirán <b className="blue">{charges.length}</b> cargo(s) por <b className="blue">{formatCurrency(this.total(), currency)}</b> a
                    la cuenta de <b className="blue">{target.GuestName || `la pieza ${target.PieceLabel}`}</b>.
                </h6>
                <h6 className="gray text-center poppins font-10 mt-2">Ambas cuentas serán recalculadas y la operación quedará registrada en los Logs de las dos reservas.</h6>
                {this.state.error && <h6 className="red text-center poppins font-10 mt-3">{this.state.error}</h6>}
                <div className="d-flex justify-content-center mt-4">
                    {!micro && <button onClick={() => this.setState({ confirming: false })} type="button" className="btn btn-lg btn-gray-2 white ms-3 align-self-center">
                        <i className="fas fa-times white font-12" />
                    </button>}
                    <button onClick={this.onTransfer} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center">
                        <i className={`fas fa-${micro ? 'cog fa-spin' : 'check'} white font-12`} />
                    </button>
                </div>
            </div>
        </div>
    }

    render() {
        const { target, confirming, currency } = this.state, { charges, source } = this.props;

        return <div style={{ position: 'fixed', zIndex: 1000, top: 0, bottom: 0, left: 100, right: 0, overflowY: 'auto' }} className="bg-gray-2">
            <div className="d-flex mx-4 mt-4">
                <div className="d-flex flex-column">
                    <span className="poppins white font-16">Transferir cargos</span>
                    <span className="poppins gray font-10">
                        Seleccione la pieza del huésped que asumirá {charges.length === 1 ? 'este cargo' : `estos ${charges.length} cargos`}
                        {source ? ` desde la Cuenta Auxiliar ${source.PieceLabel}` : ' desde la Cuenta Maestra'}
                    </span>
                </div>
                <button onClick={() => this.props.onCancel && this.props.onCancel()} className="btn btn-link rounded ms-auto"><i className="fas fa-times-circle gray font-18" /></button>
            </div>
            <hr className="mx-4" />

            <div className="d-flex mx-4" style={{ alignItems: 'flex-start' }}>
                {/* Destinos */}
                <div className="w-100 pe-4">
                    <div className="black-input bg-gray-3 d-flex mb-3" style={{ borderRadius: 6 }}>
                        <i className="fas fa-search gray align-self-center ps-3" />
                        <input className="w-100 p-3 white bg-transparent" type="text" placeholder="Buscar por pieza, huésped o reserva..."
                            value={this.state.query} onChange={e => this.setState({ query: e.target.value })} />
                    </div>
                    {this.renderTargets()}
                </div>

                {/* Resumen + destino */}
                <div style={{ width: 340, flexShrink: 0 }}>
                    {this.renderCharges()}
                    {this.renderDestination()}
                    {this.state.error && !confirming && <span className="poppins red font-10 d-block mt-3">{this.state.error}</span>}
                    <button disabled={!target}
                        onClick={() => target && this.setState({ confirming: true, error: null })}
                        className={`btn ${target ? 'btn-blue' : 'btn-gray-2'} white poppins font-12 w-100 mt-3`}>
                        <i className="fas fa-arrow-right me-2" />
                        {target ? `Transferir a la pieza ${target.PieceLabel}` : 'Seleccione una pieza destino'}
                    </button>
                    <button onClick={() => this.props.onCancel && this.props.onCancel()} className="btn btn-link gray poppins font-10 w-100 mt-2">Cancelar</button>
                </div>
            </div>
            <div style={{ height: 60 }} />

            {confirming && target && this.renderConfirmation()}
        </div>
    }
}

export default TransferCharges;
